import getWorkoutsPlanUtil from '../../../../modules/plan/model/utils/get-workouts'
import { WORKOUT_KEY } from '../../../../modules/workout/model/constants/key'
import { getObjectUtil } from 'packages/src'
import getCurrentPlanSelect from '../get-current'
import getStartedPlanSelect from '../get-started'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../redux/utils/get-instance'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import WORKOUTS_PATH from '../../../workout/redux/constants/path'
import sortByArrayUtil from 'packages/src/modules/array/sort-by'

function getAllWorkoutsPlanSelector (planParam) {
  return state => {
    let plan = (
      planParam || getCurrentPlanSelect(state) || getStartedPlanSelect(state)
    )
    if (!plan) {
      return []
    }
    plan = getInstanceReduxUtil(state, plan)
    const workoutPointers = getWorkoutsPlanUtil(plan)
    if (!Array.isArray(workoutPointers)) {
      return []
    }
    const workoutsDomainMap = getObjectUtil(state, WORKOUTS_PATH.DATA)
    const workouts = []
    workoutPointers.forEach(pointer => {
      const workout = workoutsDomainMap[getIdReduxUtil(pointer)]
      workouts.push(workout)
    })
    return sortByArrayUtil(workouts, workout => {
      return new Date(getValueReduxUtil(
        workout,
        WORKOUT_KEY.PLANNED_AT
      )).getTime()
    })
  }
}

export default getAllWorkoutsPlanSelector
